import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import { isEmptyVal, isNotEmpty, displayField } from "../../../utils/helpers";

const ContactPersonCell = ({ rowData, ...props }: { rowData: any }) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  const speaker = (
    <Popover title={t("CONTACT_PERSON")}>
      <p>
        <b>{t("CONTACT_PERSON1")}</b>
      </p>
      <p>
        <b>{t("NAME")} :</b>
        {displayField(rowData.contact_person1_name)}
      </p>
      <p>
        <b>{t("EMAIL")} :</b>
        {displayField(rowData.contact_person1_email)}
      </p>
      <p>
        <b>{t("PHONE")} :</b>
        {displayField(rowData.contact_person1_phone)}
      </p>
      <p>
        <b>{t("CONTACT_PERSON2")}</b>
      </p>
      <p>
        <b>{t("NAME")} :</b>
        {displayField(rowData.contact_person2_name)}
      </p>
      <p>
        <b>{t("EMAIL")} :</b>
        {displayField(rowData.contact_person2_email)}
      </p>
      <p>
        <b>{t("PHONE")} :</b> {displayField(rowData.contact_person2_phone)}
      </p>
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper
        placement="top"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a>
          {(isNotEmpty(`${rowData.contact_person1_name}`) &&
            `${rowData.contact_person1_name}`) ||
            displayField(rowData.contact_person2_name)}
        </a>
      </Whisper>
    </Cell>
  );
};

export default ContactPersonCell;
